import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { Logo } from "@/components/site/Logo";
import { ThemeToggle } from "@/components/site/Header";
import { Reveal } from "@/components/site/Reveal";

const Section = ({ title, children, testid }) => (
  <section data-testid={testid} className="mt-12">
    <h2 className="font-serif text-2xl font-medium text-gold sm:text-3xl">
      {title}
    </h2>
    <div className="mt-5 space-y-4 text-sm leading-relaxed text-mute sm:text-base">
      {children}
    </div>
  </section>
);

export default function MentionsLegales() {
  return (
    <main data-testid="legal-page" className="min-h-screen">
      <header className="border-b border-ink-line">
        <div className="mx-auto flex h-[72px] max-w-4xl items-center justify-between px-6">
          <Link to="/" aria-label="Retour à l'accueil">
            <Logo />
          </Link>
          <div className="flex items-center gap-3">
            <ThemeToggle compact />
            <Link
              to="/"
              data-testid="legal-back-link"
              className="group flex items-center gap-2 font-mono text-xs uppercase tracking-[0.2em] text-mute transition-colors duration-300 hover:text-gold"
            >
              <ArrowLeft className="h-4 w-4 transition-transform duration-300 group-hover:-translate-x-1" />
              Retour au site
            </Link>
          </div>
        </div>
      </header>

      <div className="mx-auto max-w-4xl px-6 py-16 lg:py-24">
        <Reveal>
          <p className="font-mono text-xs uppercase tracking-[0.28em] text-gold/90">
            Informations réglementaires
          </p>
          <h1 className="mt-5 font-serif text-4xl font-medium leading-tight tracking-tight text-ivory sm:text-5xl">
            Mentions légales &{" "}
            <em className="italic text-gold">politique de confidentialité</em>
          </h1>
        </Reveal>

        <Reveal delay={0.1}>
          <Section title="Éditeur du site" testid="legal-editor-section">
            <p>
              Le site est édité par <strong className="text-ivory">ALMALEX Legal Consulting</strong>,
              représenté par Armelle Mugobe Lehila, juriste d'affaires et de
              conformité.
            </p>
            <p>
              Adresse : 138 avenue Victor Hugo, 75016 Paris, France
              <br />
              Téléphone : +33 6 21 13 30 49
              <br />
              E-mail : lehilamugobe@gmail.com
            </p>
            <p>Directrice de la publication : Armelle Mugobe Lehila.</p>
          </Section>

          <Section title="Hébergement" testid="legal-hosting-section">
            <p>
              Ce site est hébergé au sein de l'infrastructure cloud de la
              plateforme Emergent. Les données sont hébergées au sein de
              l'Union européenne ou dans des zones offrant des garanties
              équivalentes.
            </p>
          </Section>

          <Section title="Propriété intellectuelle" testid="legal-ip-section">
            <p>
              L'ensemble des contenus du site (textes, identité visuelle, logo,
              photographies, mise en page) est la propriété exclusive d'ALMALEX
              Legal Consulting, sauf mention contraire. Toute reproduction,
              représentation ou diffusion, totale ou partielle, sans autorisation
              écrite préalable est interdite.
            </p>
          </Section>

          <Section title="Données personnelles (RGPD)" testid="legal-rgpd-section">
            <p>
              Dans le cadre du formulaire de contact, les données suivantes
              peuvent être collectées : nom, adresse e-mail, nom de la structure
              et contenu du message.
            </p>
            <p>
              <strong className="text-ivory">Finalité :</strong> ces données sont
              utilisées exclusivement pour répondre à votre demande et, le cas
              échéant, établir une relation précontractuelle.
            </p>
            <p>
              <strong className="text-ivory">Base légale :</strong> l'exécution
              de mesures précontractuelles et l'intérêt légitime de l'éditeur à
              traiter les demandes qui lui sont adressées.
            </p>
            <p>
              <strong className="text-ivory">Durée de conservation :</strong> les
              données sont conservées pendant une durée maximale de trois (3)
              ans à compter du dernier échange, sauf obligation légale
              contraire.
            </p>
            <p>
              <strong className="text-ivory">Vos droits :</strong> conformément
              au Règlement (UE) 2016/679 (RGPD) et à la loi Informatique et
              Libertés, vous disposez d'un droit d'accès, de rectification,
              d'effacement, de limitation, d'opposition et de portabilité de vos
              données. Vous pouvez exercer ces droits par e-mail à
              lehilamugobe@gmail.com. Vous disposez également du droit
              d'introduire une réclamation auprès de la CNIL (www.cnil.fr).
            </p>
          </Section>

          <Section title="Cookies" testid="legal-cookies-section">
            <p>
              Ce site n'utilise pas de cookies à des fins publicitaires ou de
              prospection commerciale. Seuls des traceurs techniques strictement
              nécessaires au fonctionnement et à la mesure d'audience anonymisée
              du site peuvent être déposés.
            </p>
          </Section>

          <Section title="Droit applicable" testid="legal-law-section">
            <p>
              Les présentes mentions légales sont soumises au droit français.
              Tout litige relatif à l'utilisation du site relève de la
              compétence des tribunaux français.
            </p>
          </Section>
        </Reveal>
      </div>
    </main>
  );
}
